import {init, Models, RematchRootState, RematchDispatch} from "@rematch/core";
import loadingPlugin, {ExtraModelsFromLoading} from "@rematch/loading";

import {auth} from "./auth";
import {app} from "./app";
import {dict} from "./dict";
import {baseData} from "./baseData";

export interface RootModel extends Models<RootModel> {
    auth: typeof auth
    app: typeof app
    dict: typeof dict
    baseData: typeof baseData
}

type FullModel = ExtraModelsFromLoading<RootModel>

const models: RootModel = {
    auth, app, dict, baseData
}

export const store = init<RootModel, FullModel>({
    models: models,
    plugins: [loadingPlugin()]
})


export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel, FullModel>
